module.exports = "<app-cabeceraadmin [ampa]=\"ampa\">\n\n  <!-- /.Main -->\n</app-cabeceraadmin>\n<div class=\"container mt-20\" >\n  <h1>Video-ayuda</h1>\n\n      <iframe width=\"100%\" height=\"480\" src=\"https://www.youtube.com/embed/wrP7Inuq_Lk\" frameborder=\"0\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/adminvideoayuda/adminvideoayuda.component.html
// module id = ./src/app/adminvideoayuda/adminvideoayuda.component.html
// module chunks = main